export default {
  phases: {
    development:
      "Collaboration d'experts en informatique afin de batir une infrastructure de serveurs.",
    implementation: 'Discussion entre trois spécialistes de la technologie.',
    logo: "CEIAE - Centre d'expertise de l'intelligence artificielle en éducation pour la réussite des élèves du Québec.",
    maintenance:
      "Ordinateur de bureau en train d'effectuer des tâches de maintenance.",
    management: 'Serveur et données protégées dans le nuage.',
    planning: 'Ampoule.',
  },
}
